import { provideTransloco, Translation, TranslocoLoader, TranslocoModule } from '@ngneat/transloco';
import { inject, Injectable, NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import { DefaultLocale, LocalesArray } from '@markant-platform/shared/data-access';
import { provideTranslocoDateTransformer, provideTranslocoLocale } from '@ngneat/transloco-locale';
import { provideTranslocoMessageformat } from '@ngneat/transloco-messageformat';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomDateTransformer } from './transformers/custom-date-transformer';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http: HttpClient = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    return this.http.get<Translation>(`${environment.baseHref}assets/i18n/${lang}.json`);
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: LocalesArray.map(locale => locale.shorthand),
        defaultLang: DefaultLocale.shorthand,
        fallbackLang: DefaultLocale.shorthand,
        missingHandler: {
          useFallbackTranslation: true,
          allowEmpty: true,
        },
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoMessageformat(),
    provideTranslocoLocale({
      // because we use the locale string in lower case (de-de),we need to map it to the correct locale with uppercase region string (de-DE)
      langToLocaleMapping: LocalesArray.reduce((acc: Record<string, string>, locale) => {
        acc[locale.shorthand] = locale.shorthand
          .split('-')
          .map((part, index) => (index === 1 ? part.toUpperCase() : part))
          .join('-');
        return acc;
      }, {}),
      localeConfig: {
        localeBased: {
          'de-DE': {
            date: {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            },
          },
        },
      },
    }),
    provideTranslocoDateTransformer(CustomDateTransformer),
  ],
})
export class TranslocoRootModuleNgneat {}
